import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { getAllAppRole, getAllClaimsByRole, getRoleClaim, setSelectedRole, updateAppRole } from "../../features/admin5/admin5Slice";
import { useSelector } from "react-redux";
import { useState } from "react";
import TopMenus from "../../components/shared/TopMenus";
import InputText from "../../components/shared/input/new/InputText";
import Btn from "../../components/shared/button/Btn";
import AdminRolYetkiContainer from "../../components/adminContainers/AdminRolYetkiContainer";
import { FiInfo } from "react-icons/fi";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    .info-text{
        width: calc(100% - 60px);
        margin: 30px 30px 0 30px; 
        display: flex;
        align-items: center;
        gap: 10px;
        svg{
            color: #E85446;
        }
        p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
        }
    }
    .content {
        width: calc(100% - 60px);
        margin: 30px;
        display: flex;
        justify-content: space-between;
        .role-list{
            display: flex;
            flex-direction: column;
            width: 300px;
            gap: 15px;
            .role-item{
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px 0;
                background-color: ${({theme}) => theme.secondaryBgColor};
                border-radius: 5px;
                cursor: pointer;
                .role-name{
                    font-size: var(--font-size-md);
                    font-weight: var(--font-weight-lg);
                    color: ${({theme}) => theme.mainTextColor};
                }
            }
            .active-role{
                background-color: var(--color-main);
                .role-name{
                    color: #fff;
                }
            }
        }
        .action-side{
            width: calc(100% - 350px);
            display: flex;
            flex-direction: column;
            gap: 30px;
            .update-role-name{
                display: flex;
                flex-direction: column;
                gap: 20px;
                width: 50%;
                margin: 0 auto;
            }
        }
    }
  }
`;

const menuData = [
    {
      id:0,
      text:"İsim Güncelleme"
    },
    {
      id:1,
      text:"Yetki Güncelleme"
    }
  ]

  const allowedRoleNames = [
    "ShipperAdmin",
    "CooperativeAdmin",
    "DigitalLogisticsAdmin",
    "EgeYurtAdmin",
    "DigitalLogisticsShipperAdmin"
  ];

const AdminKullaniciRolIslemleri = () => {
    const dispatch = useDispatch()
    const {appRoleList, selectedRole} = useSelector((state) => state.admin5)
    const [changeableRole, setChangeableRole] = useState([])
    const [activeMenuId, setActiveMenuId] = useState(0)
    const [roleName, setRoleName] = useState("")

    useEffect(() => {
        if(selectedRole){
            setRoleName(selectedRole?.name || "")
        }
    }, [selectedRole])
    
    useEffect(() => {
        dispatch(getAllAppRole())
        dispatch(getAllClaimsByRole())
    }, [])

    useEffect(() => {
        dispatch(getRoleClaim({role: selectedRole?.name}))
    }, [selectedRole])

    const handleUpdateRoleName = () => {
        if(selectedRole && roleName !== ""){
            const updateData = {
                id: selectedRole?.roleId,
                name: roleName
            }
            dispatch(updateAppRole(updateData))
        }
    }

    useEffect(() => {
        const filteredRoles = appRoleList.filter(role => allowedRoleNames.includes(role.name));
        setChangeableRole(filteredRoles)
    }, [appRoleList])

    
  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Kullanıcı Rol İşlemleri"} position="sticky" />
        <div className="info-text">
            <FiInfo size={30} />
            <p>Rol adı değiştirme her rol için geçerlidir. <br/> Yetki güncelleme işlemi ise sadece: {changeableRole.map(item => item.name).join(", ")} rolleri için geçerlidir.</p>
        </div>
      <div className="content">
        <div className="role-list">
            {appRoleList && appRoleList.map((item) => (
                <div onClick={() => dispatch(setSelectedRole(item))} className={`role-item ${selectedRole?.roleId === item?.roleId ? "active-role" : ""} `} key={item.id}>
                    <div className="role-name">{item.name}</div>
                </div>
            ))}
        </div>
        {
            selectedRole && 
            <div className="action-side">
                <TopMenus menuList={menuData} activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId} />

                {activeMenuId === 0 && 
                    <div className="update-role-name">
                        <InputText data={roleName} setData={(e) => setRoleName(e.target.value)} name={"roleName"} labelText="Rol Adı" />
                        <Btn bgColor="transparent" color="#E85446" handleClick={handleUpdateRoleName} width={"100%"}>Güncelle</Btn>
                    </div>
                }
                {(activeMenuId === 1 && (selectedRole?.name === "ShipperAdmin" || selectedRole?.name === "CooperativeAdmin" ||  selectedRole?.name === "DigitalLogisticsAdmin" || selectedRole?.name === "EgeYurtAdmin" || selectedRole?.name === "DigitalLogisticsShipperAdmin")) &&
                    <AdminRolYetkiContainer />
                }
                {/* {(activeMenuId === 1 && (selectedRole?.name !== "ShipperAdmin" || selectedRole?.name !== "CooperativeAdmin" ||  selectedRole?.name !== "DigitalLogisticsAdmin" || selectedRole?.name !== "EgeYurtAdmin" || selectedRole?.name !== "DigitalLogisticsShipperAdmin")) &&
                    <div>Bu rol için yetkilendirme işlemi yapılamamaktadır.</div>
                } */}
            </div>
        }
        
      </div>
    </div>
  </Container>
  )
}

export default AdminKullaniciRolIslemleri